module.exports = __webpack_public_path__ + "static/img/off.cd94694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/off.png
// module id = 41
// module chunks = 1